// extracted by mini-css-extract-plugin
export var currencyInput = "_jc-1";
export var currencySymbol = "_jc-0";